import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../auth/api";
import { alertSuccess, alertError } from "../components/Alert";

// Fetch Mail Box Data 
// export const fetchMailBox = createAsyncThunk(
//   "mailBox/fetchMailBox",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await api.get("/surveyHistory/panel/mailBox");
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

export const fetchMailBox = createAsyncThunk(
  "mailBox/fetchMailBox",
  async ({ page = 1, search = "", fetchAll = false, pageSize = 10 } = {}, { rejectWithValue }) => {
    try {
      let url = "/surveyHistory/panel/mailBox";

      if (!fetchAll) {
        url += `?page=${page}&page_size=${pageSize}`;
      } else {
        url += `?page=1&page_size=10000`; // fetch all users if needed
      }

      if (search) {
        url += `&search=${search}`;
      }

      const response = await api.get(url);

      return {
        data: response.data,
        page,
        search,
        pageSize,
         fromCache: false,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Add Mail to the Box
export const addMailBox = createAsyncThunk(
  "mailBox/addMailBox",
  async (newMailData, { rejectWithValue }) => {
    try {
      const response = await api.post("/surveyHistory/panel/mailBox", newMailData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Update Mail Box Data
export const updateMailBox = createAsyncThunk(
  "mailBox/updateMailBox",
  async (mailData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/surveyHistory/panel/mailBox", mailData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Mail Box Slice
const mailBoxSlice = createSlice({
  name: "mailBox",
  initialState: {
    mailBoxList: { result: [], pagination: { count: 0 } },
  search: "",
  currentPage: 1,
  pageSize: 10,
  totalPages: 1,
  status: "idle",
  error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    // ✅ Set current page
  setPage: (state, action) => {
    state.currentPage = action.payload;
  },

  // ✅ Set page size
  setPageSize: (state, action) => {
    state.pageSize = action.payload;
    state.currentPage = 1; // reset page
  },

  // ✅ Set search
  setSearch: (state, action) => {
    state.search = action.payload;
    state.currentPage = 1; // reset page
  },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Mail Box Data
      .addCase(fetchMailBox.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchMailBox.fulfilled, (state, action) => {
        const { data, page, search, pageSize } = action.payload;

        state.mailBoxList = data || { result: [], pagination: { count: 0 } };
        state.currentPage = page;
        state.search = search;
        state.pageSize = pageSize;

        const totalCount = data?.pagination?.count || 0;
        state.totalPages = Math.ceil(totalCount / pageSize);

        state.status = "succeeded";
      })
      .addCase(fetchMailBox.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Add Mail to Box
      .addCase(addMailBox.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addMailBox.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addMailBox.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Update Mail Box
      .addCase(updateMailBox.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateMailBox.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateMailBox.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearError , setSearch, setPageSize ,setPage } = mailBoxSlice.actions;

export default mailBoxSlice.reducer;
